import { getBrowserCompatibility } from './browserCompatibility';
import { renderStartupFailure } from './renderStartupFailure';

// The app imports must stay dynamic. Importing App or the Shell barrel here can
// evaluate unsupported dependencies before the compatibility screen renders.
export const startApplication = async (compatibility) => {
    try {
        const browser = compatibility || getBrowserCompatibility();
        if (!browser.supported) {
            const { default: render } = await import('../pages/UnsupportedBrowser/render');
            await render(browser);
        } else {
            const { default: render } = await import('../renderApplication');
            await render();
        }
    } catch (error) {
        console.error('Failed to start TimelyGrader.', error);
        renderStartupFailure();
    }
};
